import React from 'react'
import PropTypes from 'prop-types'

import Breadcrumbs from './../block/Breadcrumbs'
import WhiteBlockTitle from './../block/WhiteBlockTitle'

import styles from './../style/TextPage.module.scss'

import { Container } from 'react-bootstrap'

class TextPage extends React.Component {

  render() {

    const { data } = this.props

    return (
      <>
        <Breadcrumbs items={data?.breadcrumbs || []} />
        <Container>
          <div className={styles.section}>
            <WhiteBlockTitle
              title={data?.pagetitle}
              text={``}
            />
            <div className={styles.text} dangerouslySetInnerHTML={{__html: data?.content}} />
          </div>
        </Container>
      </>
    )
  }
}

TextPage.propTypes = {
  data: PropTypes.object,
  protocol: PropTypes.string,
  assets_path: PropTypes.string
}

TextPage.defaultProps = {
  data: {},
  protocol: 'https',
  assets_path: 'assets'
}

export default TextPage